import React from 'react';
import ChapterCards from './components/ChapterCards';
export default function CardsForBlogsNoNike({ in_json = [] }) {
  return <div style={{ background: '#1e1e1e', padding: 24, marginTop: 60 }}><ChapterCards entries={in_json} /></div>;
}
